import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    @Inject('Window') private window: Window
  ) {}

  async initialize(): Promise<void> {
    this.logger.info('initializing app...');
    // Probe the backend so the MaintenanceInterceptor can send the SPA to the
    // maintenance page before anything renders. Uses the app's API_HOST (not a
    // dev-server proxy), so it works the same on dev, ssl and prod. A 503
    // { error: 'maintenance' } triggers the redirect inside the interceptor;
    // any other outcome is ignored and the app boots normally.
    try {
      await firstValueFrom(
        this.http.get(`${environment.API_HOST}/api/maintenance`)
      );
    } catch (error) {
      // Non-maintenance errors must not block app startup.
      this.logger.error(
        `Maintenance probe failed for ${environment.API_HOST}`,
        error
      );
    }
    // here we would e.g. VideoService.loadAndUpdateSignedCookie only if we are
    // not on the login page and authenticated. This is needed once
    // ProxyStackProps.cloudfrontTrustedKeyGroup (infrastructure project) is enabled
  }
}
